const TRAILING_SLASH_PATTERN = /\/+$/

export function cleanSupabaseUrl(value: string | undefined): string | undefined {
  const cleaned = value?.replace(/\\n/g, '').trim().replace(TRAILING_SLASH_PATTERN, '')
  return cleaned && cleaned.length > 0 ? cleaned : undefined
}
